// Содержимое модуля «Обучение»: разделы по ролям, пошаговые инструкции, скриншоты.
// Скриншоты лежат в public/tutorial_img/<файл>.png (отдаются как есть, без сборки).

export const ROLES = [
  {code: 'all', title: 'Общее', icon: 'info', roleIds: []},
  {code: 'impl', title: 'Подрядчик', icon: 'engineering', roleIds: [1]},
  {code: 'abp', title: 'АБП', icon: 'account_balance', roleIds: [2]},
  {code: 'appr', title: 'Согласующий / Утверждающий', icon: 'fact_check', roleIds: [3, 4]},
  {code: 'book', title: 'Бухгалтер', icon: 'calculate', roleIds: [6]},
  {code: 'dzo', title: 'Администратор ДЗО', icon: 'admin_panel_settings', roleIds: [7]},
];

export const VIDEOS = [
  {title: 'Подрядная организация', file: '/impls.mp4',
    text: 'Регистрация, профиль, создание акта, назначение подписантов и отправка на согласование.'},
  {title: 'АБП: модуль «Договоры»', file: '/abp_contracts_module.mp4',
    text: 'Создание и редактирование карточки договора, прикрепление подрядчика.'},
  {title: 'АБП: модуль «Акты»', file: '/abp_acts_module.mp4',
    text: 'Работа с актом на статусе «На Администраторе Бюджетной Программы».'},
  {title: 'Согласующий', file: '/apprs.mp4', text: 'Согласование и отклонение акта.'},
  {title: 'Утверждающий', file: '/ratificator.mp4', text: 'Утверждение и подписание акта.'},
  {title: 'Подписание ЭЦП', file: '/act_sign.mp4', text: 'Подписание акта через NCALayer.'},
  {title: 'Групповое подписание', file: '/group_sign.mp4', text: 'Подписание нескольких актов за один раз.'},
];

export const PDFS = [
  {title: 'Инструкция для подрядчика (PDF)', file: '/docs/tutorial_impl.pdf', roles: ['impl']},
  {title: 'Инструкция для АБП (PDF)', file: '/docs/tutorial_abp.pdf', roles: ['abp', 'dzo']},
  {title: 'Инструкция для согласующих и утверждающих (PDF)', file: '/docs/tutorial_appr.pdf', roles: ['appr']},
];

export const SUPPORT = {
  phone: '8 707 492 71 44',
  phoneHref: 'tel:87074927144',
  email: 'support-avr@prodev.kz',
};

// Статусы акта — единый справочник для всех разделов
export const STATUSES = [
  {name: 'Черновик', who: 'Подрядчик', text: 'Акт сохранён как черновик и ещё не отправлялся на согласование (встречается редко).'},
  {name: 'На подрядчике', who: 'Подрядчик', text: 'Акт создан или возвращён на доработку. Подрядчик может редактировать акт, назначить подписантов и отправить на согласование.'},
  {name: 'На подписании у подрядчика', who: 'Подписанты подрядчика', text: 'Акт проходит согласование и подписание ЭЦП внутри организации подрядчика.'},
  {name: 'На Администраторе Бюджетной Программы', who: 'АБП', text: 'Акт у АБП заказчика: он проверяет акт, прикладывает файлы и назначает список подписантов заказчика.'},
  {name: 'На последовательном согласовании', who: 'Согласующие заказчика', text: 'Каждый согласующий получает акт по очереди, в порядке, заданном АБП.'},
  {name: 'На параллельном согласовании', who: 'Согласующие заказчика', text: 'Все согласующие получают акт одновременно.'},
  {name: 'На утверждении', who: 'Утверждающий', text: 'Акт согласован и ожидает подписи утверждающего заказчика.'},
  {name: 'Подписано, посредством ЭЦП', who: '—', text: 'Финальный статус: акт подписан всеми сторонами, доступен PDF с QR-кодом для проверки.'},
  {name: 'Подписано, без ЭЦП', who: '—', text: 'Финальный статус для актов, подписанных без ЭЦП (исторические акты).'},
];

export const SECTIONS = [
  // ---------------------------------------------------------------- Общее
  {
    id: 'about', role: 'all', title: 'Что такое AVR+ и как устроен процесс',
    intro: 'AVR+ — система электронного согласования и подписания актов выполненных работ (оказанных услуг) между ' +
        'подрядчиками и ТОО «Ойл Транспорт Корпорейшэн». Подрядчик формирует акт по договору, акт проходит подписание ' +
        'внутри подрядчика, затем попадает к Администратору бюджетной программы (АБП) заказчика, далее — к согласующим ' +
        'и утверждающему. Все подписи ставятся электронной цифровой подписью (ЭЦП) через программу NCALayer.',
    steps: [
      {title: 'Роли в системе', img: 'landing.png', text:
        '<ul>' +
        '<li><b>Подрядная организация</b> — создаёт акты по договорам, назначает своих подписантов, подписывает акты ЭЦП.</li>' +
        '<li><b>АБП (Администратор бюджетной программы)</b> — ведёт карточки договоров, принимает акт от подрядчика, назначает подписантов заказчика.</li>' +
        '<li><b>Согласующий / Утверждающий (подписанты)</b> — согласовывают, отклоняют и подписывают акты ЭЦП.</li>' +
        '<li><b>Бухгалтер</b> — видит все акты, выгружает отчёты в Excel, удаляет ошибочные акты.</li>' +
        '<li><b>Администратор системы по ДЗО</b> — подтверждает регистрации, управляет пользователями и ролями, смотрит статистику и просроченные согласования.</li>' +
        '</ul>'},
      {title: 'Путь акта по статусам', text:
        'Каждый акт всегда находится в одном из статусов. Статус показан на странице акта и в списке актов цветной меткой: ' +
        'красная — акт ждёт действий подрядчика, жёлтая — акт в процессе согласования у заказчика, зелёная — акт подписан. ' +
        'Полный список статусов приведён в таблице ниже.', statuses: true},
    ],
  },
  {
    id: 'login', role: 'all', title: 'Вход в систему и восстановление пароля',
    steps: [
      {title: 'Вход по логину и паролю', img: 'login.png', text:
        'Откройте адрес системы, введите логин (как правило, это ИИН или адрес электронной почты, выданный при регистрации) ' +
        'и пароль, нажмите «Войти». После входа открывается главная страница с плитками быстрого меню; боковое меню разделов ' +
        'появляется на внутренних страницах.',
        tips: ['Логин и пароль вводятся без пробелов. Если вход не удаётся — проверьте раскладку клавиатуры и Caps Lock.',
          'Первый пароль, выданный администратором, рекомендуется сразу сменить в профиле.']},
      {title: 'Вход по ЭЦП', text:
        'На странице входа доступна кнопка «Вход через ЭЦП». Для этого на компьютере должна быть запущена программа NCALayer ' +
        'и подключён ключ (файл GOST или на носителе). После выбора ключа система найдёт ваш профиль по ИИН из сертификата.',
        tips: ['Вход по ЭЦП работает только если в профиле ранее была обновлена регистрационная карта ЭЦП (кнопка «Обновить ЭЦП»).']},
      {title: 'Восстановление пароля', text:
        'Нажмите «Забыли пароль?» на странице входа, укажите логин или почту — на электронную почту, указанную в профиле, ' +
        'придёт письмо с новым паролем. Если письмо не приходит, проверьте папку «Спам» или обратитесь в поддержку.'},
    ],
  },
  {
    id: 'ecp', role: 'all', title: 'ЭЦП и NCALayer',
    intro: 'Все подписи в системе ставятся электронной цифровой подписью Национального удостоверяющего центра РК. ' +
        'Для работы с ЭЦП на компьютере должна быть установлена и запущена программа NCALayer.',
    steps: [
      {title: 'Установка NCALayer', text:
        'Скачайте NCALayer с официального сайта НУЦ РК (pki.gov.kz), установите и запустите. Значок программы появится в трее. ' +
        'Браузер должен иметь доступ к адресу wss://127.0.0.1:13579 — не блокируйте его антивирусом или корпоративным прокси.'},
      {title: 'Если система пишет «Убедитесь, что программа NCALayer запущена»', img: 'ncalayer_error.png', text:
        'Это сообщение появляется, когда браузер не смог соединиться с NCALayer. Запустите программу (или перезапустите её), ' +
        'обновите страницу и повторите действие.',
        tips: ['В некоторых браузерах требуется один раз открыть https://127.0.0.1:13579 и принять сертификат NCALayer.',
          'Если ключ на носителе (Казтокен, удостоверение личности) — вставьте носитель до нажатия кнопки подписания.']},
      {title: 'Регистрационная карта ЭЦП в профиле', img: 'profile.png', text:
        'Перед первым подписанием откройте «Профиль» и нажмите «Обновить ЭЦП». Выберите ключ в NCALayer — система сохранит ' +
        'данные сертификата (ИИН, срок действия). Подписывать акты можно только ключом, ИИН которого совпадает с ИИН в профиле.',
        tips: ['При перевыпуске ключа обязательно повторите «Обновить ЭЦП», иначе подписание будет отклонено.']},
    ],
  },
  {
    id: 'profile', role: 'all', title: 'Профиль, уведомления, чат и предложения',
    steps: [
      {title: 'Профиль', img: 'profile.png', text:
        'В профиле можно сменить пароль, электронную почту, должность и телефон, обновить ЭЦП. Подрядчик дополнительно ' +
        'задаёт ставку НДС своей организации («Редактировать НДС») и может отправить «Запрос на редактирование профиля компании» ' +
        '(наименование, адрес) — запрос подтверждает администратор ДЗО.'},
      {title: 'Уведомления', img: 'notifications.png', text:
        'Все события по вашим актам и договорам (создание, отправка на согласование, отклонение, подписание) приходят в раздел ' +
        '«Уведомления» и дублируются письмом на почту из профиля. Нажатие на уведомление открывает соответствующий акт или договор.'},
      {title: 'Чат', img: 'chat.png', text:
        'Раздел «Чат» — переписка с коллегами и участниками согласования внутри системы. Удобно уточнять замечания по акту, не выходя из AVR+.'},
      {title: 'Предложения', img: 'offers.png', text:
        'В разделе «Предложения» можно отправить пожелание или сообщить об ошибке — сообщение уходит разработчикам.'},
    ],
  },
  {
    id: 'verification', role: 'all', title: 'Проверка подписанного акта по QR-коду',
    steps: [
      {title: 'QR-код на PDF', text:
        'На PDF подписанного акта печатается QR-код. Отсканировав его, любой человек (без входа в систему) увидит страницу ' +
        'проверки с реквизитами акта, строками и данными подписантов. Так можно убедиться, что распечатанный акт соответствует ' +
        'подписанному в системе.'},
    ],
  },

  // ---------------------------------------------------------------- Подрядчик
  {
    id: 'impl-registration', role: 'impl', title: 'Регистрация подрядной организации',
    steps: [
      {title: 'Заполнение формы регистрации', img: 'registration.png', text:
        'На странице входа нажмите «Регистрация». Выберите «Я сотрудник подрядной организации», заполните ИИН, ФИО, электронную почту, ' +
        'телефон, должность и реквизиты организации (БИН, наименование, адрес). Если организация уже зарегистрирована в системе — ' +
        'выберите её из списка по БИН, иначе создайте новую.',
        tips: ['Электронная почта должна быть рабочей: на неё приходят уведомления и пароль при восстановлении.',
          'Регистрируйте пользователей только с действующей ЭЦП: без неё подписать акт нельзя.']},
      {title: 'Модерация', text:
        'После отправки формы заявка попадает к администратору ДЗО. После подтверждения на почту придёт письмо, и можно входить в систему. ' +
        'До подтверждения вход невозможен.'},
    ],
  },
  {
    id: 'impl-contracts', role: 'impl', title: 'Договоры',
    steps: [
      {title: 'Список договоров', img: 'contracts_list.png', text:
        'Раздел «Договоры» показывает договоры вашей организации. Карточку договора создаёт АБП заказчика — подрядчик её ' +
        'не создаёт и не редактирует. Вкладки: «Активные» / «Завершенные», поиск по номеру и наименованию. ' +
        'При создании карточки договора все пользователи вашей организации получают уведомление и письмо.'},
      {title: 'Карточка договора', img: 'contract_view.png', text:
        'В карточке — номер, наименование, срок действия, заказчик, АБП, скан оригинала, дополнительные файлы, список актов по договору ' +
        'и сумма подписанных актов. Здесь же видно, включён ли по договору режим «Ручной ввод сумм в актах».',
        tips: ['Если договор не появился в списке — обратитесь к АБП заказчика: возможно, карточка ещё не создана или прикреплена к другой организации.']},
    ],
  },
  {
    id: 'impl-act-create', role: 'impl', title: 'Создание акта: пошагово',
    intro: 'Акт создаётся из раздела «Акты» кнопкой «Создать акт»: сначала в окне выбирается тип акта, затем открывается мастер ' +
        'из шагов «Параметры», «Приложения» и «Таблица». Кнопка «Продолжить» становится активной, когда заполнены все ' +
        'обязательные поля шага; на последнем шаге акт сохраняется кнопкой «Сохранить», назад — «Вернуться».',
    steps: [
      {title: 'Шаг «Параметры»', img: 'act_create_step1.png', text:
        'Тип акта (Стандартный, ДКС, ДБиКРС, Обучение персонала, КС проживание, КС авиабилеты) выбирается в окне перед мастером. ' +
        'На шаге «Параметры» укажите номер акта, наименование, дату и договор из списка. Тип даты строки (период или конкретная дата) ' +
        'выбирается позже — при добавлении каждой строки в таблице и один раз при скачивании шаблона Excel.',
        tips: ['Номер акта должен совпадать с номером на бумажном оригинале, если он есть.',
          'Дата акта не может быть позже текущей даты.']},
      {title: 'Шаг «Приложения»', img: 'act_create_step2.png', text:
        'Приложите дополнительные файлы (PDF, JPG, PNG): счёт-фактуру, отчёт, фотографии. Для актов с фотофиксацией можно ' +
        'загрузить пары фотографий «до / после».'},
      {title: 'Шаг «Таблица» — строки акта', img: 'act_create_rows.png', text:
        'Заполните строки акта: наименование работ, дату (или период), сведения об отчёте, единицу измерения, количество и цену. ' +
        'Стоимость строки, «Итого», «Сумма НДС» и «Всего» считаются автоматически. Ставка НДС берётся из профиля вашей организации; ' +
        'сумму НДС можно поправить вручную.',
        tips: ['Кнопка «+» добавляет строку в конец, «−» справа от строки убирает её.',
          'Сумма по каждой строке не может быть нулевой — акт с такой строкой не сохранится.']},
      {title: 'Заголовки групп строк (стандартный акт)', img: 'act_create_headers.png', text:
        'При нажатии «+» выберите тип: <b>Строка акта</b> или <b>Заголовок (группа строк)</b>. Заголовок — это жирная строка без номера ' +
        'и без цены: у него заполняется только наименование, а количество и стоимость считаются автоматически по строкам, ' +
        'расположенным ниже до следующего заголовка. Нумерация строк сквозная: если в первой группе 10 строк, первая строка второй ' +
        'группы получит номер 11. Порядок строк и заголовков — любой, заголовков может быть сколько угодно.',
        tips: ['Заголовки не входят в «Итого» — итог всегда считается только по строкам.',
          'Акт из одних заголовков сохранить нельзя: нужна хотя бы одна строка.']},
      {title: 'Загрузка строк из Excel', img: 'act_excel_upload.png', text:
        'На шаге «Таблица» нажмите ссылку «скачать шаблон (excel)», в окне укажите количество строк и тип даты и нажмите «Скачать шаблон». ' +
        'Заполните файл и верните его в систему кнопкой «загрузить обратно». ' +
        'Заполняются только ячейки со знаком «*». В колонке I «Тип строки» выберите из списка «Строка» или «Заголовок»: для заголовка ' +
        'заполняется только наименование, остальные ячейки строки блокируются. Незаполненные строки шаблона пропускаются.',
        tips: ['Даты — в формате дд.мм.гггг, период — дд.мм.гггг...дд.мм.гггг.',
          'Если в файле ошибка, система покажет номер строки Excel и что именно исправить, например: «Строка №2 (строка Excel 10): не заполнена „Единица измерения“ (колонка E)».',
          'После загрузки строки можно править прямо в таблице.']},
      {title: 'Ручной ввод сумм (если включён по договору)', img: 'act_create_manual_totals.png', text:
        'Если АБП включил по договору режим «Ручной ввод сумм в актах», в таблице появляется подсказка и кнопка «Пересчитать по строкам». ' +
        'В этом режиме можно вручную ввести стоимость каждой строки, количество и стоимость заголовков, а также «Итого», «Сумму НДС» и «Всего» — ' +
        'система сохранит их как есть. Если введённое значение не сходится с расчётом (количество × цена или сумма по группе), ячейка ' +
        'подсвечивается и показывается предупреждение — оно информационное, сохранение не блокируется.',
        tips: ['Кнопка «Пересчитать по строкам» возвращает автоматический расчёт всех сумм.']},
      {title: 'Сохранение', img: 'act_view_impl.png', text:
        'После сохранения открывается страница акта в статусе «На подрядчике». Действия на странице акта — кнопки-иконки с подсказками: ' +
        '«Редактировать», «Создать копию», «Назначить список подписантов», «Удалить», «Скачать акт», «Скачать историю согласования». ' +
        'Кнопка «Отправить на согласование» появляется после назначения подписантов.'},
    ],
  },
  {
    id: 'impl-signers', role: 'impl', title: 'Подписанты подрядчика и отправка на согласование',
    steps: [
      {title: 'Назначение подписантов', img: 'act_assign_signers.png', text:
        'На странице акта нажмите «Назначить список подписантов». Выберите сотрудников вашей организации, порядок и режим ' +
        '(последовательное — по очереди, параллельное — одновременно) и укажите утверждающего — того, кто ставит финальную подпись ' +
        'от подрядчика. Изменить уже назначенный список можно кнопкой «Назначить новый список подписантов».',
        tips: ['В списке видны только сотрудники вашей организации с подтверждённой регистрацией.']},
      {title: 'Отправка на согласование', text:
        'Нажмите «Отправить на согласование» — акт перейдёт в статус «На подписании у подрядчика», подписанты получат уведомления. ' +
        'После подписания утверждающим подрядчика акт автоматически уходит АБП заказчика.'},
      {title: 'Подписание ЭЦП', img: 'act_sign_modal.png', text:
        'Когда акт на вас, на его странице появляется кнопка «Подписать посредством ЭЦП». Нажмите её, выберите ключ в окне NCALayer ' +
        'и введите пароль от ключа. Подпись фиксируется в истории акта.'},
      {title: 'Отклонение и возврат акта', img: 'act_history.png', text:
        'Если согласующий заказчика или АБП отклонил акт, он возвращается в статус «На подрядчике» с комментарием — его видно в истории ' +
        'акта и в уведомлении. Исправьте акт (кнопка «Редактировать») и отправьте заново. Историю согласования можно скачать в PDF.'},
      {title: 'Отзыв акта', text:
        'Пока акт не подписан заказчиком, подрядчик может отозвать его кнопкой «Отозвать» — акт вернётся в статус «На подрядчике».'},
    ],
  },
  {
    id: 'impl-pdf', role: 'impl', title: 'PDF акта, история и копия',
    steps: [
      {title: 'Скачать акт PDF', text:
        'Кнопка «Скачать акт» формирует PDF в утверждённой форме. У подписанного акта в PDF есть QR-код и данные всех подписантов.'},
      {title: 'Скачать шаблон (XLS) с данными', text:
        'У подписанного акта доступна кнопка «Скачать шаблон (XLS)» — выгрузка строк акта в Excel для проверки и повторного использования.'},
      {title: 'Создать копию', text:
        'Кнопка «Создать копию» создаёт новый акт с теми же строками и параметрами — измените номер, дату и суммы.'},
    ],
  },

  // ---------------------------------------------------------------- АБП
  {
    id: 'abp-contracts', role: 'abp', title: 'Карточки договоров',
    steps: [
      {title: 'Создание договора', img: 'contract_create.png', text:
        'В разделе «Договоры» нажмите «Создать». Укажите номер, наименование, срок действия (даты начала и завершения), выберите ' +
        'подрядчика по наименованию или БИН, загрузите скан оригинала (PDF) и при необходимости дополнительные файлы. ' +
        'Опции: <b>Консорциум</b> — второй поставщик по договору; <b>Зеркальный договор</b> — когда вы выступаете исполнителем, ' +
        'а акты создаёт ваша организация.',
        tips: ['После создания все пользователи подрядчика получают уведомление и письмо со ссылкой на договор.',
          'АБП договора — вы. Администратор ДЗО при создании может выбрать другого АБП.']},
      {title: 'Флаг «Ручной ввод сумм в актах (Итого / НДС / Всего)»', img: 'contract_create.png', text:
        'Отметьте этот флажок, если по договору подрядчик должен вводить суммы вручную (нестандартный расчёт НДС, округления, суммы по ' +
        'группам). Тогда в стандартных актах подрядчик сможет править стоимость строк, количество и стоимость заголовков, «Итого», ' +
        '«Сумму НДС» и «Всего», а система сохранит введённые значения. При выключенном флаге все суммы считаются автоматически. ' +
        'Флаг можно включить или выключить позже при редактировании договора — изменение попадёт в историю договора.'},
      {title: 'Редактирование и удаление', img: 'contract_view.png', text:
        'В карточке договора АБП-владелец может изменить реквизиты, заменить основной файл, добавить файлы, сменить АБП. ' +
        'Удалить договор можно только пока по нему нет актов. Все изменения фиксируются во вкладке «История».'},
    ],
  },
  {
    id: 'abp-acts', role: 'abp', title: 'Акт на статусе «На Администраторе Бюджетной Программы»',
    steps: [
      {title: 'Проверка акта', img: 'act_view_abp.png', text:
        'Когда подрядчик подписал акт, он приходит вам в статусе «На АБП». Проверьте строки, суммы, файлы. При замечаниях нажмите ' +
        '«Отклонить» и укажите причину — акт вернётся подрядчику.'},
      {title: 'Файлы АБП', text:
        'На этом статусе АБП может приложить к акту свои файлы (от 1 до 10): служебные записки, расчёты. Они видны всем участникам согласования.'},
      {title: 'Назначение подписантов заказчика', img: 'act_assign_signers.png', text:
        'Нажмите «Назначить список подписантов», выберите согласующих, порядок и режим (последовательный или параллельный) и утверждающего. ' +
        'Для следующих актов по этому договору список подписантов заказчика подставляется автоматически из ранее назначенного; ' +
        'изменить его можно кнопкой «Назначить новый список подписантов».'},
      {title: 'Отправка на согласование', text:
        'После назначения нажмите «Отправить на согласование». Акт перейдёт согласующим; вы получите уведомление на каждом этапе.'},
      {title: 'Зеркальные акты', text:
        'По зеркальному договору АБП сам создаёт акт: в разделе «Акты» кнопка «Создать акт» доступна АБП, у которого есть зеркальные договоры. ' +
        'Подписантов со стороны заказчика также назначает АБП.'},
    ],
  },

  // ---------------------------------------------------------------- Согласующий / Утверждающий
  {
    id: 'appr-flow', role: 'appr', title: 'Согласование и утверждение акта',
    steps: [
      {title: 'Где найти акты, ожидающие меня', img: 'acts_list.png', text:
        'В разделе «Акты» откройте вкладку «На мне» — здесь только акты, по которым требуется ваше действие. Остальные вкладки ' +
        '(«Все акты», «На подрядчике», «АБП», «На согласовании», «На утверждении», «Завершенные») показывают акты по статусам. ' +
        'Работает поиск по номеру акта, договору и БИН подрядчика.'},
      {title: 'Проверка акта', img: 'act_view_impl.png', text:
        'На странице акта: реквизиты, таблица строк с заголовками групп и итогами, файлы подрядчика и АБП, история согласования и ' +
        'кто уже подписал. PDF акта можно скачать для печати.'},
      {title: 'Согласовать / Отклонить', text:
        '«Согласовать» — акт уходит следующему по списку (или утверждающему). «Отклонить» — обязательно укажите причину; ' +
        'акт вернётся подрядчику на доработку, а вы и АБП получите уведомление.'},
      {title: 'Подписание ЭЦП утверждающим', img: 'act_sign_modal.png', text:
        'Утверждающий ставит финальную подпись: кнопка «Подписать посредством ЭЦП» → выбор ключа в NCALayer → пароль. ' +
        'После подписи акт переходит в статус «Подписано, посредством ЭЦП».',
        tips: ['ИИН ключа должен совпадать с ИИН профиля и с регистрационной картой ЭЦП («Обновить ЭЦП» в профиле).']},
      {title: 'Групповое подписание', img: 'acts_group_sign.png', text:
        'Утверждающий во вкладке «На мне» отмечает несколько актов флажками и нажимает «Подписать выбранные» — открывается окно ' +
        '«Подписать через ЭЦП», NCALayer запрашивает ключ один раз и подписывает все отмеченные акты.'},
    ],
  },

  // ---------------------------------------------------------------- Бухгалтер
  {
    id: 'book-flow', role: 'book', title: 'Контроль актов и отчёты',
    steps: [
      {title: 'Все акты и фильтры', img: 'booker_acts.png', text:
        'Бухгалтеру доступны все акты всех подрядчиков. Дополнительные вкладки: «На АБП», «На согласовании», «На утверждении», ' +
        '«Не завершенные», «Архивированные». Фильтры по году и месяцу, поиск по договору, номеру акта и БИН.'},
      {title: 'Выгрузка в Excel', text:
        'Кнопка «Скачать EXCEL» формирует реестр актов по выбранным фильтрам (номер, договор, подрядчик, суммы, статус, даты подписания). ' +
        'На странице подписанного акта кнопка «Скачать шаблон (XLS)» выгружает строки конкретного акта.'},
      {title: 'Удаление ошибочных актов', text:
        'Кнопка «Удалить акт» удаляет ошибочный акт; для подписанных актов используется «Удалить акт (Запрос)» — запрос на удаление ' +
        'с указанием причины, который подтверждается второй стороной. Удалённые акты в списках не показываются.'},
      {title: 'Архив', text:
        'Кнопки «Переместить в архив» / «Убрать из архива» убирают акт из рабочих списков в персональный архив и обратно.'},
    ],
  },

  // ---------------------------------------------------------------- Администратор ДЗО
  {
    id: 'dzo-users', role: 'dzo', title: 'Пользователи, заявки и роли',
    steps: [
      {title: 'Заявки на регистрацию', img: 'users_admin.png', text:
        'Раздел «Администрирование»: вкладка «Заявки на регистрацию» содержит новые регистрации. Проверьте ИИН, организацию и должность, затем ' +
        '«Подтвердить аккаунт» (пользователь получит письмо) или «Отклонить аккаунт».'},
      {title: 'Пользователи и роли', text:
        'Вкладка «Активные пользователи» — все аккаунты: смена ролей (подрядчик, АБП, согласующий, утверждающий, бухгалтер, экономист), ' +
        'кнопка «Архивировать пользователя» для уволенных сотрудников. Роль определяет, какие разделы и кнопки видит пользователь.'},
      {title: 'Профили компаний', text:
        'Вкладка «Заявки на редактирование профиля компании»: подтверждение запросов подрядчиков на изменение реквизитов (наименование, адрес) с приложенным документом.'},
    ],
  },
  {
    id: 'dzo-control', role: 'dzo', title: 'Договоры, сроки согласования и статистика',
    steps: [
      {title: 'Договоры всех АБП', img: 'contracts_list.png', text:
        'Администратор ДЗО видит договоры всех АБП с фильтром по АБП и при создании договора может назначить любого АБП ответственным.'},
      {title: 'Сроки согласования', img: 'overdue.png', text:
        'Раздел «Сроки согласования» показывает, у кого и сколько дней находится акт сверх нормативного срока. Список выгружается кнопкой «Скачать EXCEL».'},
      {title: 'Статистика', img: 'statistics.png', text:
        'Раздел «Статистика»: количество актов по статусам и месяцам, нагрузка по АБП, суммы. Доступна выгрузка в Excel.'},
    ],
  },
];
